import { createAsyncThunk } from "@reduxjs/toolkit"
import apiRequest from "../../lib/http"
import { normalizeError } from "../../utils/errorHelpers"

export const SIGNING_LINK_NOT_SENT = 'The signing link was not sent. Try again.'

const sendFailureMessage = (error) => (
  error?.response?.data?.error ? normalizeError(error) : SIGNING_LINK_NOT_SENT
)

export const emailSigningLink = createAsyncThunk('signingLink/email', async ({ userId, email, lsaTemplateType }, { rejectWithValue }) => {
  try {
    const response = await apiRequest.post(`/mails/bank-info/users/${userId}`, { email, lsaTemplateType })
    return response.data
  } catch (error) {
    return rejectWithValue(sendFailureMessage(error))
  }
})

export const textSigningLink = createAsyncThunk('signingLink/text', async ({ userId, phoneNumber, lsaTemplateType }, { rejectWithValue }) => {
  try {
    const response = await apiRequest.post(`/sms/bank-info/users/${userId}`, { phoneNumber, lsaTemplateType })
    return response.data
  } catch (error) {
    return rejectWithValue(sendFailureMessage(error))
  }
})
